import isEqual from 'lodash/isEqual';
import { Filter, useFilterContext } from './FilterContext';
import { SortParam, useListContext } from '../ListContext';
import { getActiveFilters } from './useFilter';
import assert from 'assert';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../../ui/mui-builder/Button/Button';

interface QuickFilterAndSortProps {
  label: string;
  state: Filter;
  defaultSort: SortParam;
  className?: string;
}

const QuickFilterAndSort = ({ label, state, defaultSort, className }: QuickFilterAndSortProps) => {
  const { quickFilter, filters } = useFilterContext();
  const { sortBy, sort } = useListContext();
  const { Button: ThemedButton = Button } = useUiTheme();

  const onClick = () => {
    assert(!!quickFilter && !!sortBy, 'quickfilters and sortBy should not be undefined');

    sortBy(defaultSort.field, defaultSort.order);
    quickFilter(state);
  };

  return (
    <ThemedButton
      disableFocusRipple
      onClick={onClick}
      variant="text"
      type="button"
      disabled={isEqual(getActiveFilters(filters), state) && isEqual(sort, defaultSort)}
      className={className}
    >
      {label}
    </ThemedButton>
  );
};

export default QuickFilterAndSort;
